import { render, staticRenderFns } from "./veStuPunish.vue?vue&type=template&id=911a17da&scoped=true"
import script from "./veStuPunish.vue?vue&type=script&lang=js"
export * from "./veStuPunish.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "911a17da",
  null
  
)

export default component.exports